import React, { useEffect, useState } from 'react';
import ColorModel from './models/ColorModel';

function AddColor({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(() => new ColorModel());

  const propagateChange = (nextState) => {
    setFormData(nextState);
    if (typeof sendDataToParent === 'function') {
      sendDataToParent(nextState);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.currentTarget;
    propagateChange({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (typeof onLoad === 'function') {
      onLoad(new ColorModel());
    }
    if (typeof sendDataToParent === 'function') {
      sendDataToParent(formData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="row">
      <div className="mb-3">
        <label className="form-label">
          Color Name<span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="ColorName"
          value={formData.ColorName || ''}
          onChange={handleChange}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Color Code</label>
        <input
          type="text"
          className="form-control"
          name="ColorCode"
          placeholder="#FFFFFF or descriptive code"
          value={formData.ColorCode || ''}
          onChange={handleChange}
        />
      </div>
      <div className="col-lg-12">
        <div className="summer-description-box transfer mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control h-100"
            rows="5"
            name="Description"
            value={formData.Description || ''}
            onChange={handleChange}
          />
          <p className="mt-1">Maximum 1000 Characters</p>
        </div>
      </div>
    </div>
  );
}

export default AddColor;
